module.exports = __webpack_public_path__ + "static/0091-03587360c2a71547b39bc30f64eeb5e5.png";